<template lang="pug">
  .b-crm-page
    CrmBoardApi(
      :companyId="companyId"
      :funnelId="funnelId"
      :leadId="leadId"
      @openLead="openLead"
      @closeLead="closeLead"
      )
</template>

<script>
import CrmBoardApi from '@/components/crm/CrmBoardApi.vue';
import { markVisited } from '@/utils/newPage';

/**
 * Страница CRM — вкладка компании: лэйаут и меню компании рендерит
 * CompanyDetailPage (см. router/modules/company.js).
 *
 * Держит только связь с адресом: компания и открытая заявка приходят из роута
 * и уходят в доску пропами, а доска сообщает о клике по карточке и о закрытии
 * попапа. Всё остальное — данные, права и попапы — в CrmBoardApi.
 */
export default {
  name: 'CrmPage',
  components: { CrmBoardApi },
  mounted() {
    markVisited('crm');
  },
  computed: {
    companyId() { return this.$route.params.companyId; },
    /**
     * У шторки заявки собственный роут, см. router/modules/company.js. В нём
     * вместе с заявкой стоит и её воронка: по прямой ссылке доска должна
     * открыться на той воронке, где лежит заявка, а сама заявка о воронке не
     * знает — только об этапе. Без заявки в адресе воронки нет: её выбирают
     * на доске.
     */
    funnelId() { return this.$route.params.funnelId ?? null; },
    leadId() { return this.$route.params.leadId ?? null; },
  },
  methods: {
    openLead({ leadId, funnelId }) {
      if (Number(this.$route.params.leadId) === leadId) return;
      this.$router.push({ name: 'crm-lead', params: { companyId: this.companyId, funnelId, leadId } });
    },
    closeLead() {
      if (!this.$route.params.leadId) return;
      this.$router.push({ name: 'crm', params: { companyId: this.companyId } });
    },
  },
};
</script>
